module.exports = __webpack_public_path__ + "static/media/2.df84b9e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2.jpg
// module id = 88
// module chunks = 0